import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { resolveBousalaProduct } from "@/lib/bousala/products";

/**
 * Admin-only mirror of `getBousalaBuyContext().product`: returns the catalog
 * row even when it is not active yet. Anyone who is not a signed-in admin gets
 * `{ product: null }`, which is exactly what the public sees.
 *
 * Deliberately separate from `getBousalaBuyContext` so the public function and
 * its 60-second global cache stay untouched.
 */
export const getSmartAdminPreview = createServerFn({ method: "GET" })
  .validator((d: unknown) =>
    z.object({ product: z.enum(["v1", "smart"]).optional() }).parse(d ?? {}),
  )
  .handler(async ({ data }) => {
    const { requestIsAdmin } = await import("@/lib/bousala/smart-preview.server");
    const isAdmin = await requestIsAdmin();
    if (!isAdmin) return { product: null, isAdmin: false };

    const def = resolveBousalaProduct(data.product ?? "smart");
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { smartProductForViewer } = await import("@/lib/bousala/smart-preview");
    const product = await smartProductForViewer(supabaseAdmin, def.slug, true);
    return { product: product ?? null, isAdmin: true };
  });
